export default __webpack_public_path__ + "static/media/lightWallets.2151c9b8.png";